import { Pipe, PipeTransform } from '@angular/core';

import { isTextOnlyGuestChatRoom } from 'src/shared/util/text-only-guest-chat-room';

// True for guest conversations TIDY can only send text into (anything but an SMS
// room), so the attach button is hidden. `isGuest` covers a guest thread that has
// no room key yet.
@Pipe({
  name: 'isTextOnlyGuestChatRoom',
  standalone: true,
})
export class IsTextOnlyGuestChatRoomPipe implements PipeTransform {
  transform(chatRoomKey: string | null | undefined, isGuest = false): boolean {
    return isTextOnlyGuestChatRoom(chatRoomKey, !!isGuest);
  }
}
